import { buildAicopyBoomShareSlides } from "@/utils/sharePosterSlides";

export const AICOPY_BOOM_ADD_POSITION_EVENT = "aicopy-boom-add-position";

/** 解析 boom-popup 响应（兼容 code/data 与 rc/result） */
export function parseBoomPopupPayload(res) {
  if (!res || typeof res !== "object") return null;
  if (typeof res.code === "number" && res.code === 0 && res.data && typeof res.data === "object") {
    return res.data;
  }
  if (typeof res.rc === "number" && res.rc === 0) {
    const payload = res.result?.data ?? res.result;
    return payload && typeof payload === "object" ? payload : null;
  }
  if (res.needPopup != null) return res;
  return null;
}

function parseNumericText(raw) {
  const text = String(raw ?? "")
    .replace(/,/g, "")
    .trim();
  if (!text) return null;
  const n = Number(text);
  return Number.isFinite(n) ? n : null;
}

/** 接口百分数字段（10.2 = +10.2%）→ 展示百分比 */
export function formatBoomPopupPercentRate(raw, formatNumberFn) {
  const n = parseNumericText(raw);
  if (n == null) return "—";
  if (n === 0) return "0%";
  const sign = n > 0 ? "+" : "-";
  const absStr = Math.abs(n)
    .toFixed(2)
    .replace(/\.?0+$/, "");
  const display = formatNumberFn ? formatNumberFn(absStr) : absStr;
  return `${sign}${display}%`;
}

/** strategyReturnRate 小数（0.102 = 10.2%）→ 展示百分比（兼容字段） */
export function formatBoomPopupReturnRate(raw, formatNumberFn) {
  const text = String(raw ?? "")
    .replace(/,/g, "")
    .trim();
  if (!text) return "—";
  try {
    let percent = Number(text);
    if (!Number.isFinite(percent)) return "—";
    if (percent !== 0 && Math.abs(percent) <= 1) {
      percent *= 100;
    }
    return formatBoomPopupPercentRate(percent, formatNumberFn);
  } catch {
    return "—";
  }
}

/** aum USDT */
export function formatBoomPopupAum(raw, formatNumberFn) {
  const n = parseNumericText(raw);
  if (n == null) return "—";
  const fixed = n.toFixed(2).replace(/\.?0+$/, "");
  const display = formatNumberFn ? formatNumberFn(fixed) : fixed;
  return `${display} USDT`;
}

/** userProfit USDT，最多 6 位小数 */
export function formatBoomPopupUserProfit(raw, formatNumberFn) {
  const text = String(raw ?? "")
    .replace(/,/g, "")
    .trim();
  if (!text) return "—";
  const n = Number(text);
  if (!Number.isFinite(n)) return "—";
  const fixed = n.toFixed(6).replace(/\.?0+$/, "");
  const display = formatNumberFn ? formatNumberFn(fixed) : fixed;
  const sign = n > 0 ? "+" : n < 0 ? "-" : "";
  const absDisplay = sign ? display.replace(/^[-+]/, "") : display;
  return `${sign}${absDisplay} USDT`;
}

export function getBoomPopupPercentTone(raw) {
  const n = parseNumericText(raw);
  if (n == null) return "neutral";
  if (n > 0) return "up";
  if (n < 0) return "down";
  return "neutral";
}

export function isMockBoomPopupPreview(query) {
  const v = query?.mockBoomPopup;
  if (v == null) return false;
  const s = String(v).toLowerCase();
  return s === "1" || s === "true" || s === "yes";
}

export function buildMockBoomPopupPayload() {
  return {
    needPopup: true,
    recordId: "mock_batchId_userId",
    strategyId: "16",
    strategyName: "Gemini Dual-Track Stable Model",
    strategyReturnRate: "0.102",
    userProfit: "1.540000",
    aum: "1386802.000000",
    newestPositionReturnRate: "10.2",
    totalHoldingsReturnRate: "1.3",
    inviteCode: "MOCK123",
    inviteLink: "https://www.example.com/register?code=MOCK123",
    __mock: true,
  };
}

/** 爆点分享海报：专用底图 + AUM / 最新平仓 / 累计持仓收益率 */
export function buildBoomPopupShareSlidesFromPayload(payload, formatNumberFn) {
  if (!payload) return [];
  return buildAicopyBoomShareSlides({
    strategyName: payload.strategyName || "",
    aum: formatBoomPopupAum(payload.aum, formatNumberFn),
    newestPositionReturnRate: formatBoomPopupPercentRate(payload.newestPositionReturnRate, formatNumberFn),
    totalHoldingsReturnRate: formatBoomPopupPercentRate(payload.totalHoldingsReturnRate, formatNumberFn),
  });
}

/** 仅 /aicopy 首页触发爆点弹窗 */
export function isAicopyBoomPopupRoute(pathname) {
  const path = String(pathname || "").replace(/\/$/, "");
  return path === "/aicopy";
}

/** 打开跟单/加仓（移动端 sheet / PC follow drawer） */
export function dispatchAicopyBoomAddPosition({ strategyId, strategyName }) {
  if (typeof window === "undefined" || strategyId == null || strategyId === "") return;
  window.dispatchEvent(
    new CustomEvent(AICOPY_BOOM_ADD_POSITION_EVENT, {
      detail: { strategyId: String(strategyId), strategyName: strategyName || "" },
    }),
  );
}
